import { FixDictionary } from "./FixDictionary";

export class DictionaryLoader {
  private static dictionaries = new Map<string, Promise<FixDictionary>>();

  static getDictionary(
    dialect: string,
    prefix: string
  ): Promise<FixDictionary> | null {
    let dictionaryF = DictionaryLoader.dictionaries.get(dialect);
    if (!dictionaryF) {
      dictionaryF = this.load(dialect, prefix);
      DictionaryLoader.dictionaries.set(dialect, dictionaryF);
    }
    return dictionaryF;
  }

  private static async load(
    dialect: string,
    prefix: string
  ): Promise<FixDictionary> {
    const url = `${prefix}/${dialect}.json`;
    return fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`${url} : ${response.statusText}`);
        }
        return response.json();
      })
      .then((json) => {
        return Object.setPrototypeOf(json, FixDictionary.prototype);
      });
  }

  static createDictionary(data: any): FixDictionary {
    const dictionary: FixDictionary = Object.setPrototypeOf(
      data,
      FixDictionary.prototype
    );
    if (!!dictionary) {
      DictionaryLoader.dictionaries.set(
        dictionary.name,
        Promise.resolve(dictionary)
      );
    }
    return dictionary;
  }
}
